import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import React, {useState} from "react";
import {DialogContent, DialogContentText, DialogTitle, MenuItem} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {AutoComplete} from "../openings/AutoComplete";
import {Alternative} from "../../../../api/QuoteAlternatives";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {useProjectId} from "../ProjectName";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {div10TabKeys, Div10TypeToName} from "./Div10Tabs";
import {SelectWithLabel} from "../../quote/hardware/SelectWithLabel";
import {useEventEmitter} from "../../../../misc/UseEventEmitter";
import {div10CurrentTab, Div10ForceUpdate} from "./Div10";

export function CopyDiv10FromQuoteMode(props: {}) {
    const [show, setShow] = useState(false)

    return (
        <>
            <SmallGreyButton onClick={() => setShow(true)}>
                Copy from Quote Mode
            </SmallGreyButton>
            {show && <CopyDiv10Dialog onClose={() => setShow(false)} />}
        </>
    )
}

export function CopyDiv10Dialog(props: {
    onClose(): void;
}) {
    const div10Tab = useEventEmitter(div10CurrentTab);
    const project = useProjectId();
    const [alternative, setAlternative] = useState<Alternative|null>(null);
    const onCloseRef = useSyncedRef(props.onClose);

    const action = useAsyncAction(async (input) => {
        await api.div10.overwriteFromQuoteMode(input);
        onCloseRef.current();
        Div10ForceUpdate.emit(Date.now())
    }, [])

    const [tab, setTab] = useState(div10Tab || div10TabKeys[0])

    return (
        <Dialog2 open onClose={() => props.onClose()}>
            <DialogTitle>
                Copy Div10 from Quote Mode
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}}/>

                <DialogContentText>
                    This will overwrite the current div10 products with the div10 from the quote alternative selected.
                </DialogContentText>

                <div style={{height: 8}}/>

                <AutoComplete<Alternative>
                    fullWidth
                    label="Choose Alternative"
                    search={async input => {
                        let result = await getAll(null, offset => api.quoteAlternatives.list({
                            project: project,
                            offset: offset,
                        }))

                        if (input !== "") {
                            input = input.toLowerCase();
                            result = result.filter(r => r.name.toLowerCase().indexOf(input) !== -1)
                        }

                        return result;
                    }}
                    value={alternative}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={a => a.name}
                    onSelect={setAlternative}
                />

                <div style={{height: 16}}/>
                <SelectWithLabel label="Section" value={tab} onChange={(e) => setTab(e.target.value as string)}>
                    {div10TabKeys.map(k => <MenuItem key={k} value={k}>{Div10TypeToName(k)}</MenuItem>)}
                </SelectWithLabel>
                <div style={{height: 16}}/>
            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error}
                actionName="Overwrite & Copy"
                submitDisabled={!alternative}
                onCancel={() => props.onClose()}
                onSubmit={() => {
                    action.callback({
                        project: project,
                        alternative: alternative!.id,
                        category: tab,
                    })
                }}
            />
        </Dialog2>
    )
}